
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicles-we-build/[slug]",
      function () {
        return require("private-next-pages/vehicles-we-build/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicles-we-build/[slug]"])
      });
    }
  